import Cookies from 'js-cookie';
import { login, logout, getInfo, refreshToken } from '@/api/login'
import { getToken, setToken, setExpiresIn, removeToken } from '@/utils/auth'
const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    permissions: []
  },
  mutations: {
    logout(state, vm) {
      Cookies.remove('user');
      Cookies.remove('password');
      Cookies.remove('access');
      // 恢复默认样式
      let themeLink = document.querySelector('link[name="theme"]');
      themeLink.setAttribute('href', '');
      // 清空打开的页面等数据，但是保存主题数据
      let theme = '';
      if (localStorage.theme) {
        theme = localStorage.theme;
      }
      var userName = localStorage["userName"]
      localStorage.clear();
      localStorage["userName"] = userName;
      if (theme) {
        localStorage.theme = theme;
      }
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_EXPIRES_IN: (state, time) => {
      state.expires_in = time
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    }
  },
  actions:{
    // 登录
    Login({ commit }, userInfo) {
      console.log(userInfo);
      console.log(userInfo,commit);
      const username = userInfo.username.trim()
      const password = userInfo.password
      const code = userInfo.code
      const uuid = userInfo.uuid
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid).then(res => {
          let data = res.data
          Cookies.set('user', userInfo.username);
          window.localStorage['Authorization']=data.access_token;
          localStorage.setItem('userName',username);
          localStorage.setItem('password',password)
          setToken(data.access_token)
          commit('SET_TOKEN', data.access_token)
          setExpiresIn(data.expires_in)
          commit('SET_EXPIRES_IN', data.expires_in)
          let provinceId = null;
          let cityId = null;
          let areaId = null;
          let provinceName = null;
          let cityName = null;
          let areaName = null;
          let showName = null
          let level = 4;
          if(data.login_user.provinceId&&data.login_user.cityId&&data.login_user.areaId){
            provinceId = data.login_user.provinceId;
            cityId = data.login_user.cityId;
            areaId = data.login_user.areaId;
            provinceName = data.login_user.provinceName;
            cityName = data.login_user.cityName;
            areaName = data.login_user.areaName;
            showName = data.login_user.areaName;
            level = 4
          }else if(data.login_user.provinceId&&data.login_user.cityId&&!data.login_user.areaId){
            provinceId = data.login_user.provinceId;
            cityId = data.login_user.cityId;
            provinceName = data.login_user.provinceName;
            cityName = data.login_user.cityName;
            showName = data.login_user.cityName;
            level = 3
          }else if(data.login_user.provinceId&&!data.login_user.cityId&&!data.login_user.areaId){
            provinceId = data.login_user.provinceId;
            provinceName = data.login_user.provinceName;
            showName = data.login_user.provinceName;
            level = 2
          }else{
            provinceId = 333000;
            cityId = 330500;
            areaId = 330521;
            provinceName = '浙江省';
            cityName = '湖州市';
            areaName = '德清县';
            showName = '德清县';
            level = 4
          }
          window.localStorage["provinceId"] = provinceId;
          window.localStorage["provinceName"] = provinceName;
          window.localStorage["cityId"] = cityId;
          window.localStorage["cityName"] = cityName;
          window.localStorage["areaId"] = areaId;
          window.localStorage["areaName"] = areaName;
          window.localStorage["level"] = level;
          window.localStorage["showcityname"] =showName;
          resolve({showName,level})
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
  }


};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js